import { render, staticRenderFns } from "./CreateButtonHeader.vue?vue&type=template&id=16245033"
import script from "./CreateButtonHeader.vue?vue&type=script&lang=js"
export * from "./CreateButtonHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports